import { BUTTON_NAMES, ScreenNames, User_Roles } from './common.model';
import { FormFieldConfig, FIELD_TYPES, ButtonFieldConfig, InfoFieldConfig, INFO_TYPES, DisplayTranformation, FieldOption } from './form.model';

const getOptionsForCalendarAndFiscalYear = (startYear: number, type: 'calendar' | 'fiscal') => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const numberOfYears = currentYear - startYear;
    const options: Array<FieldOption> = [];
    if (type === 'calendar') {
        for (let i = 0; i <= numberOfYears; i++) {
            const value = (startYear + i).toString();
            options.push({ fieldLabel: value, fieldValue: value });
        }
    } else {
        const currentMonth = today.getMonth() + 1;
        for (let i = 0; i <= numberOfYears - 1; i++) {
            const value = (startYear + i);
            options.push({ fieldLabel: `Apr ${value} - Mar ${value + 1}`, fieldValue: (value).toString() });
        }
        if (currentMonth >= 4) {
            options.push({ fieldLabel: `Apr ${currentYear} - Mar ${currentYear + 1}`, fieldValue: (currentYear).toString() });
        }
    }
    return options;
}
export const FieldTypesForOptions = [FIELD_TYPES.CHECKBOX, FIELD_TYPES.DROPDOWN];
export const westernArea = "WESTERN AREA";
export const centralArea = "CENTRAL AREA";
export const easternArea = "EASTERN AREA";
export const southernArea = "SOUTHERN AREA";
export const tenureOptions = {
    BaseTenure: 'base_tenure',
    DescritionaryTenure: 'descritionary_tenure'
}
export const FieldNames = {
    Area: "area",
    SpinId: "spinId",
    PrimaryRole: "primaryRole",
    IsPc: "isPC",
    IsCertJobRole: "isCertifiableRole",
    CertifiableRoles: "certifiableRoles",
    NonCertifiableRoles: "nonCertifiableRoles",
    FirstName: "firstName",
    LastName: "lastName",
    Certification: "certification",
    Event: 'event',
    JobRole: 'jobRole',
    Attendance: 'attendance',
    Code: 'code',
    District: 'district',
    Dealer: "dealerNumber",
    CalendarYear: "calendarYear",
    FiscalYear: "fiscalYear",
    Year: "year",
    Month: "month",
    Period: "period",
    DealerNumber: "dealerNumber",
    CourseNameCode: "courseNameCode",
    AreaDistrict: "areaDistrict",
    InvoiceNumber: "invoiceNumber",
    Delivery: "delivery",
    TotalAmount: "totalAmount",
    PaymentType: "paymentType",
    DealerCode: "dealerCode",
    CourseShortName: "courseShortName",
    CourseTitle: "course",
    Status: "status",
    StartDate: "startDate",
    endDate: 'endDate',
    CompletionDate: "completionDate",
    Facility: "facility",
    Credit: "credit",
    PeopleAttended: "peopleAttended",
    TotalCount: "totalCount",
    Ase: 'ase',
    TestTakenDate: "testTakenDate",
    ExpirationDate: "expirationDate",
    AreaRegion: "areaRegion",
    ElevateNewsletter: "ElevateNewsletter",
    EmployeeStatus: "employeeStatus",
    Brand: "brand",
    Tenure: "tenure",
    SubTenure: "SubTenure",
    WorkDayId: "workdayId",
    Email: 'email',
    UserAccessScreens: 'modules',
    UserAccessRoles: 'userRole',
    Role: 'role',
    CreatedBy: 'createdBy',
    Comments: 'comments',
    AdjustedTenure: 'adjustedTenure',
    ActualTenure: 'actualTenure',
    BrandTenure: "brandTenure",
    Attachment: "attachment",
    TenureAreaRegion: 'tenureAreaRegion',
    JobCode: 'jobCode',
    Type: 'type',
    Range: 'range',
    Name: 'fullName',
    Venue: 'venue',
    Areas: 'areas',
    IltPartStartDate: 'iltPartStartDate',
    RegistrationStatus: 'registrationStatus',
    EventTitle: 'eventTitle',
    ToyotaCertification: 'toyotaCertification',
    LexusPrimaryJobCode: 'lexusPrimaryJobCode',
    OldDealer: 'oldDealer',
    NewDealer: 'newDealer',
    fromDate: 'fromDate',
    toDate: 'toDate',
    JobStatus: 'jobStatus',
    EliteStatus: 'eliteStatus',
    EventBillingEvent: 'eventBillingEvent',
    EventBillingYear: 'eventBillingYear',
    EventDealer: 'eventDealer',
    ReportName: 'reportName',
    ReportOwner: 'reportOwner',
    EventName: 'eventName',

} as const;

export const PaymentTypeDropdownValues = [{ fieldLabel: 'Dealership', fieldValue: 'Dealership' }, { fieldLabel: 'Individual', fieldValue: 'Individual' }];
export const StatusDropdownValues = [{ fieldLabel: 'Completed', fieldValue: 'Completed' }, { fieldLabel: 'No Show', fieldValue: 'No Show' }];
const defaultYesNo = [{ fieldLabel: 'Yes', fieldValue: 'Y' }, { fieldLabel: 'No', fieldValue: 'N' }];
const today = new Date();
export const DropdownOptions = {
    [FieldNames['Area']]: [{ fieldLabel: westernArea, fieldValue: '31' }, { fieldLabel: centralArea, fieldValue: '32' }, { fieldLabel: easternArea, fieldValue: '33' }, { fieldLabel: southernArea, fieldValue: '34' }],
    [FieldNames['AreaRegion']]: [{ fieldLabel: westernArea, fieldValue: westernArea }, { fieldLabel: centralArea, fieldValue: centralArea }, { fieldLabel: easternArea, fieldValue: easternArea }, { fieldLabel: southernArea, fieldValue: southernArea }],
    [FieldNames['Month']]: [{ fieldLabel: 'January', fieldValue: '1' }, { fieldLabel: 'February', fieldValue: '2' }, { fieldLabel: 'March', fieldValue: '3' }, { fieldLabel: 'April', fieldValue: '4' }, { fieldLabel: 'May', fieldValue: '5' }, { fieldLabel: 'June', fieldValue: '6' }, { fieldLabel: 'July', fieldValue: '7' }, { fieldLabel: 'August', fieldValue: '8' }, { fieldLabel: 'September', fieldValue: '9' }, { fieldLabel: 'October', fieldValue: '10' }, { fieldLabel: 'November', fieldValue: '11' }, { fieldLabel: 'December', fieldValue: '12' }],
    [FieldNames['Period']]: [{ fieldLabel: '1 Month', fieldValue: '1' }, { fieldLabel: '3 Months', fieldValue: '3' }, { fieldLabel: '6 Months', fieldValue: '6' }, { fieldLabel: '12 Months', fieldValue: '12' }],
    [FieldNames['District']]: [{ fieldLabel: '1', fieldValue: '1' }, { fieldLabel: '2', fieldValue: '2' }, { fieldLabel: '3', fieldValue: '3' }, { fieldLabel: '4', fieldValue: '4' }, { fieldLabel: '5', fieldValue: '5' }, { fieldLabel: '6', fieldValue: '6' }],
    [FieldNames['Code']]: [{ fieldLabel: 'N', fieldValue: 'N' }, { fieldLabel: 'NR', fieldValue: 'NR' }, { fieldLabel: 'SX', fieldValue: 'SX' }, { fieldLabel: 'EX', fieldValue: 'EX' }, { fieldLabel: 'BL', fieldValue: 'BL' }],
    [FieldNames['PaymentType']]: PaymentTypeDropdownValues,
    [FieldNames['Status']]: StatusDropdownValues,
    [FieldNames['Credit']]: defaultYesNo,
    [FieldNames['Attendance']]: [{ fieldLabel: 'Completed', fieldValue: 'Completed' }, { fieldLabel: 'No Show', fieldValue: 'No Show' }, { fieldLabel: 'Cancelled', fieldValue: 'Cancelled' }],
    [FieldNames['Delivery']]: [{ fieldLabel: 'Virtual', fieldValue: 'virtual' }, { fieldLabel: 'In Person', fieldValue: 'In Person' }],
    [FieldNames['ElevateNewsletter']]: defaultYesNo,
    [FieldNames['PrimaryRole']]: [{ fieldLabel: 'Not Applied', fieldValue: 'not_applied' }, { fieldLabel: 'YES', fieldValue: 'Y' }],
    [FieldNames['IsCertJobRole']]: [{ fieldLabel: 'Not Applied', fieldValue: 'not_applied' }, { fieldLabel: 'Yes', fieldValue: 'Y' }, { fieldLabel: 'No', fieldValue: 'N' }],
    [FieldNames['Certification']]: [{ fieldValue: 'M', fieldLabel: 'Master' }, { fieldValue: 'S', fieldLabel: 'Senior' }, { fieldValue: 'C', fieldLabel: 'Foundations' }, { fieldValue: 'N', fieldLabel: 'Not Certified' }],
    [FieldNames['IsPc']]: defaultYesNo,
    [FieldNames['JobRole']]: [{ fieldValue: 'Primary', fieldLabel: 'Primary' }, { fieldValue: 'Secondary', fieldLabel: 'Secondary' }],
    [FieldNames['CalendarYear']]: getOptionsForCalendarAndFiscalYear(2022, 'calendar'),
    [FieldNames['FiscalYear']]: getOptionsForCalendarAndFiscalYear(2022, 'fiscal'),
    [FieldNames['EmployeeStatus']]: [{ fieldLabel: 'Active', fieldValue: 'Active' }, { fieldLabel: 'Inactive', fieldValue: 'Inactive' }],
    [FieldNames['EliteStatus']]: [{ fieldLabel: 'new', fieldValue: 'new' }, { fieldLabel: 'terminated', fieldValue: 'terminated' }, { fieldLabel: 'present', fieldValue: 'present' }],
    [FieldNames['Brand']]: [{ fieldLabel: 'Lexus', fieldValue: 'LEXUS' }, { fieldLabel: 'Toyota', fieldValue: 'TOYOTA' }],
    [FieldNames['Tenure']]: [{ fieldLabel: 'Base Tenure', fieldValue: tenureOptions['BaseTenure'] }, { fieldLabel: 'Discretionary Tenure', fieldValue: tenureOptions['DescritionaryTenure'] }],
    [FieldNames['UserAccessScreens']]: [{ fieldValue: ScreenNames['staffMaster'], fieldLabel: 'Staff Master' }, { fieldValue: ScreenNames['jobRoleSummary'], fieldLabel: 'Job Role Summary' }, { fieldValue: ScreenNames['dealerTrainingBilling'], fieldLabel: 'Dealers Billing' }, { fieldValue: ScreenNames['elevateBilling'], fieldLabel: 'Elevate Billing' }, { fieldValue: ScreenNames['eventBilling'], fieldLabel: 'Event Billing' }, { fieldValue: ScreenNames['aseLexus'], fieldLabel: 'ASE' }, { fieldValue: ScreenNames['lexusTurnoverReport'], fieldLabel: 'Lexus Turnover Report' }, { fieldValue: ScreenNames['pcSupport'], fieldLabel: 'PC Support' }, { fieldValue: ScreenNames['distributionList'], fieldLabel: 'Distribution List' }, { fieldValue: ScreenNames['tenure'], fieldLabel: 'Tenure' }, { fieldValue: ScreenNames['tenureAdmin'], fieldLabel: 'Tenure Admin' }, { fieldValue: ScreenNames['eventDashboard'], fieldLabel: 'Events Registration Dashboard' }, { fieldValue: ScreenNames['eliteCertificationReport'], fieldLabel: 'Elite Certification' },{ fieldValue: ScreenNames['impactAnalysis'], fieldLabel: 'Impact Analysis' }, { fieldValue: ScreenNames['survey'], fieldLabel: 'PAS - Pre Attendance Survey' }, { fieldValue: ScreenNames['information'], fieldLabel: 'Information' }],
    [FieldNames['UserAccessRoles']]: Object.entries(User_Roles).map(([key, value]) => ({ fieldValue: value, fieldLabel: key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()) })), 
    [FieldNames['Range']]: [{ fieldLabel: 'Month', fieldValue: 'month' }, { fieldLabel: 'Year', fieldValue: 'year' }],
    [FieldNames['RegistrationStatus']]: [{ fieldLabel: 'Withdrawn', fieldValue: 'Withdrawn' }, { fieldLabel: 'Registered', fieldValue: 'Registered' }],
    [FieldNames['JobStatus']]: [{ fieldLabel: 'Active', fieldValue: 'Active' }, { fieldLabel: 'Inactive', fieldValue: 'Inactive' }],
    [FieldNames['ToyotaCertification']]: [
        { fieldLabel: 'Not Certified', fieldValue: 'N' },
        { fieldLabel: 'Certified', fieldValue: 'C' },
        { fieldLabel: 'Expert', fieldValue: 'E' },
        { fieldLabel: 'Master Diagnostic', fieldValue: 'D' },
        { fieldLabel: 'Master', fieldValue: 'M' },
        { fieldLabel: 'Maintenance', fieldValue: 'T' },
        { fieldLabel: 'Truck Pro', fieldValue: 'P' },
        { fieldLabel: 'Foundations', fieldValue: 'F' },
        { fieldLabel: 'Master Recertified', fieldValue: 'R' },
        { fieldLabel: 'Guru', fieldValue: 'G' },
        { fieldLabel: 'None', fieldValue: 'N' },
        { fieldLabel: 'Repair', fieldValue: 'Re' }
    ],
    [FieldNames['ReportName']]: [
        { fieldLabel: 'Lexus Learn LFS Report', fieldValue: 'lexus-learn-lfs-report' },
        { fieldLabel: 'Elevate Report', fieldValue: 'elevate-report' },
        { fieldLabel: 'Monogram Page Suit', fieldValue: 'monogram-page-suit' },
        { fieldLabel: 'Program Consultant Report', fieldValue: 'program-consultant-report' },
        { fieldLabel: 'Service Consultants Report', fieldValue: 'service-consultants-report' }
    ],
    [FieldNames['EventName']]: [
        { fieldLabel: 'Page view', fieldValue: 'page-view' },
        { fieldLabel: 'Home Page Clicked', fieldValue: 'home-page-clicked' },
        { fieldLabel: 'Player Played', fieldValue: 'player-played' },
    ],
}

export const DefaultAphanumeric: FormFieldConfig = {
    fieldName: '', displayName: '', fieldType: FIELD_TYPES.TEXT, defaultValue: '',
    selectedValue: '', disabled: false
}
export const DefaultText: FormFieldConfig = {
    fieldName: '', displayName: '', fieldType: FIELD_TYPES.TEXT, defaultValue: '',
    pattern: String.raw`^[a-zA-Z\s-]+$`, selectedValue: '', disabled: false
}
export const DefaultTextArea: FormFieldConfig = {
    fieldName: '', displayName: '', fieldType: FIELD_TYPES.TEXTAREA, defaultValue: '',
    selectedValue: '', disabled: false
}
export const DefaultEmail: FormFieldConfig = {
    fieldName: '', displayName: '', fieldType: FIELD_TYPES.EMAIL, defaultValue: '',
    pattern: String.raw`^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$`, selectedValue: '', disabled: false
}
export const DefaultNumber: FormFieldConfig = {
    fieldName: '', displayName: '', fieldType: FIELD_TYPES.NUMBER, defaultValue: '',
    pattern: String.raw`^[0-9]*$`, selectedValue: '', disabled: false
}
export const DefaultDate: FormFieldConfig = {
    fieldName: '', displayName: '', fieldType: FIELD_TYPES.DATE, defaultValue: '',
    selectedValue: '', disabled: false
}
export const DefaultDropdown: FormFieldConfig = {
    fieldName: '', displayName: '', fieldType: FIELD_TYPES.DROPDOWN, defaultValue: '',
    selectedValue: '', options: [], disabled: false, showSelect: true, isAutoComplete: false
}
export const DefaultFile: FormFieldConfig = {
    fieldName: '', displayName: '', fieldType: FIELD_TYPES.FILE, defaultValue: '',
    selectedValue: '', disabled: false, fileTypes: [], restrictedFileTypes: ['application/x-msdownload']
}
export const DefaultCheckbox: FormFieldConfig = {
    fieldName: '', displayName: '', fieldType: FIELD_TYPES.CHECKBOX, defaultValue: '',
    selectedValue: '', options: [], disabled: false, showSelect: true
}

export const AreaDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Area, displayName: 'Area', options: DropdownOptions[FieldNames.Area], multiple: true
}

export const AreaRegionDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Area, displayName: 'Area', options: DropdownOptions[FieldNames.AreaRegion]
}

export const AreaMutipleSelect: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Area, displayName: 'Area', multiple: true, options: DropdownOptions[FieldNames.Area]
}

export const DistrictMutipleSelect: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.District, displayName: 'District', multiple: true, options: DropdownOptions[FieldNames['District']]
}
export const DistrictDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.District, displayName: 'District', options: DropdownOptions[FieldNames['District']]
}

export const CodeMutipleSelect: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Code, displayName: 'Code', multiple: true, displayTranformation: DisplayTranformation.uppercase, options: DropdownOptions[FieldNames['Code']]
}

export const EventDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Event, displayName: 'EVENT'
}

export const EventTitleDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.EventTitle, displayName: 'Event'
}

export const EventDealerDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.EventDealer, displayName: 'Dealer', isLoading: true, isAutoComplete: true
}

export const EventBillingEventDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Event, displayName: 'Event', options: [], isLoading: true, displayTranformation: DisplayTranformation.none, showSelect: false
}

export const EventBillingYearDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Year, displayName: 'Year', options: [], isLoading: true,
}

export const JobRoleDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.JobRole, displayName: 'Job Role'
}

export const PrimaryRoleDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.PrimaryRole, displayName: 'PRIMARY ROLE', options: DropdownOptions[FieldNames['PrimaryRole']]
}

export const IsPcDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.IsPc, displayName: 'Is PC', options: DropdownOptions[FieldNames['IsPc']]
}

export const IsCertJobRoleDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.IsCertJobRole, displayName: 'Is Certifiable Job Role', options: DropdownOptions[FieldNames['IsCertJobRole']]
}

export const AreaDistrictDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.AreaDistrict, displayName: 'Area District', isDependentOn: FieldNames.Area, disabled: true
}

export const CertifiableRolesDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.CertifiableRoles, displayName: 'CERTIFIABLE ROLES', isDependentOn: FieldNames.NonCertifiableRoles, multiple: true, disabled: false
}

export const NonCertifiableRolesDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.NonCertifiableRoles, multiple: true, displayName: 'Non-Certifiable Roles'
}

export const DealerDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Dealer, displayName: 'DEALER'
}

export const CertificationDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Certification, displayName: 'CERTIFICATION', multiple: true, options: DropdownOptions[FieldNames['Certification']]
}

export const DealerNumber: FormFieldConfig = {
    ...structuredClone(DefaultNumber),
    fieldName: FieldNames.Dealer, displayName: 'Dealer'
}
export const FirstNameText: FormFieldConfig = {
    ...structuredClone(DefaultText), pattern: '',
    fieldName: FieldNames.FirstName, displayName: 'First Name'
}
export const NameText: FormFieldConfig = {
    ...structuredClone(DefaultText), pattern: '',
    fieldName: FieldNames.Name, displayName: 'Name'
}
export const LastNameText: FormFieldConfig = {
    ...structuredClone(DefaultText), pattern: '',
    fieldName: FieldNames.LastName, displayName: 'Last Name'
}
export const SpinIdNumber: FormFieldConfig = {
    ...structuredClone(DefaultNumber),
    fieldName: FieldNames.SpinId, displayName: 'Spin ID', max: 12
}
export const aseID: FormFieldConfig = {
    ...structuredClone(DefaultAphanumeric),
    fieldName: FieldNames.Ase, displayName: 'ASE ID',
}
export const testTakenDate: FormFieldConfig = {
    ...structuredClone(DefaultDate),
    fieldName: FieldNames.TestTakenDate, displayName: 'Initial Test Taken Date', max: today
}
export const expirationDate: FormFieldConfig = {
    ...structuredClone(DefaultDate),
    fieldName: FieldNames.ExpirationDate, displayName: 'Expiration Date'
}
export const CalendarYearDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.CalendarYear, displayName: 'Calendar Year', options: DropdownOptions[FieldNames['CalendarYear']]
}
export const FiscalYearDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.FiscalYear, displayName: 'Fiscal Year', options: DropdownOptions[FieldNames['FiscalYear']]
}
export const YearDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Year, displayName: 'Year'
}
export const MonthDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown), showSelect: false,
    fieldName: FieldNames.Month, displayName: 'Month', options: DropdownOptions[FieldNames['Month']]
}
export const PeriodDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Period, displayName: 'Period', options: DropdownOptions[FieldNames['Period']]
}
export const DealerNumberDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.DealerNumber, displayName: 'Dealer Number', isLoading: true, isAutoComplete: true
}
export const CourseNameCodeDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.CourseNameCode, displayName: 'Course Name / Code', isLoading: true, displayTranformation: DisplayTranformation.none
}
export const InvoiceNumberText: FormFieldConfig = {
    ...structuredClone(DefaultText),
    fieldName: FieldNames.InvoiceNumber, displayName: 'Invoice Number'
}
export const AttendanceDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Attendance, displayName: 'Attendance', options: DropdownOptions['attendance'], multiple: true
}
export const DeliveryDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Delivery, displayName: 'Delivery', options: DropdownOptions[FieldNames['Delivery']], multiple: true
}
export const PaymentTypeDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.PaymentType, displayName: 'Payment Type', options: DropdownOptions[FieldNames['PaymentType']]
}
export const DealerCodeText: FormFieldConfig = {
    ...structuredClone(DefaultNumber),
    fieldName: FieldNames.DealerCode, displayName: 'Dealer Code'
}
export const CourseShortNameDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.CourseShortName, displayName: 'Course Short Name', displayTranformation: DisplayTranformation.none
}
export const CourseTitleText: FormFieldConfig = {
    ...structuredClone(DefaultAphanumeric),
    fieldName: FieldNames.CourseTitle, displayName: 'Course Title', max: 255
}
export const StatusDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Status, displayName: 'Status', options: DropdownOptions[FieldNames['Status']]
}
export const StartDateDate: FormFieldConfig = {
    ...structuredClone(DefaultDate),
    fieldName: FieldNames.StartDate, displayName: 'Start Date', max: today
}
export const CompletionDateDate: FormFieldConfig = {
    ...structuredClone(DefaultDate),
    fieldName: FieldNames.CompletionDate, displayName: 'Completion Date', max: today
}

export const EndDate: FormFieldConfig = {
    ...structuredClone(DefaultDate),
    fieldName: FieldNames.endDate, displayName: 'End Date', max: today
}

export const FromDateDate: FormFieldConfig = {
    ...structuredClone(DefaultDate),
    fieldName: FieldNames.fromDate, displayName: 'From Date', max: today
}
export const ToDateDate: FormFieldConfig = {
    ...structuredClone(DefaultDate),
    fieldName: FieldNames.toDate, displayName: 'To Date', max: today
}

export const FACILITYText: FormFieldConfig = {
    ...structuredClone(DefaultText),
    fieldName: FieldNames.Facility, displayName: 'Facility'
}
export const peopleattendedText: FormFieldConfig = {
    ...structuredClone(DefaultNumber),
    fieldName: FieldNames.PeopleAttended, displayName: '#People Attended', camelCase: true
}
export const CreditDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Credit, displayName: 'Credit', options: DropdownOptions[FieldNames['Credit']]
}
export const TotalAmountText: InfoFieldConfig = {
    fieldName: FieldNames.TotalAmount, fieldLabel: 'Total Amount ($)', value: 0, infoType: INFO_TYPES.Total, calculateBy: ''
}
export const TotalCountText: InfoFieldConfig = {
    fieldName: FieldNames.TotalCount, fieldLabel: 'Total Count', value: 0, infoType: INFO_TYPES.Count, calculateBy: ''
}

export const ElevateNewsletterDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.ElevateNewsletter, displayName: 'Elevate Newletter', options: DropdownOptions[FieldNames['ElevateNewsletter']]
}

export const NonCertifiableRolesCheckbox: FormFieldConfig = {
    ...structuredClone(DefaultCheckbox),
    fieldName: FieldNames.NonCertifiableRoles, displayName: 'Non Certifiable Roles'
}
export const CertifiableRolesCheckbox: FormFieldConfig = {
    ...structuredClone(DefaultCheckbox),
    fieldName: FieldNames.CertifiableRoles, displayName: 'Certifiable Roles'
}

export const EmpStatusDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.EmployeeStatus, displayName: 'Employee Status', options: DropdownOptions[FieldNames.EmployeeStatus]
}

export const JobStatusDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.JobStatus, displayName: 'Job Status', options: DropdownOptions[FieldNames.JobStatus]
}

export const EliteStatusDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Status, displayName: 'Status', options: DropdownOptions[FieldNames.EliteStatus]
}

export const BuySellOldDealerDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.OldDealer, displayName: 'Old Dealer', required: false, isLoading: true, isAutoComplete: true,
};

export const BuySellNewDealerDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.NewDealer, displayName: 'New Dealer', required: false, isLoading: true, isAutoComplete: true,
};

export const BrandDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Brand, displayName: 'Brand', options: DropdownOptions[FieldNames.Brand]
}

export const TenureDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Tenure, displayName: 'Select Tenure', options: DropdownOptions[FieldNames.Tenure], isDependentOn: FieldNames.SubTenure
}
export const BrandTenureText: FormFieldConfig = {
    ...structuredClone(DefaultNumber),
    fieldName: FieldNames.BrandTenure, displayName: 'Brand Tenure(in Months)'
}

export const AdjustedTenureNumber: FormFieldConfig = {
    ...structuredClone(DefaultNumber),
    fieldName: FieldNames.AdjustedTenure, displayName: 'Adjusted Tenure', required: true, pattern: String.raw`^-?[0-9]*$`
}
export const ActualTenureNumber: FormFieldConfig = {
    ...structuredClone(DefaultNumber),
    fieldName: FieldNames.ActualTenure, displayName: 'Actual Tenure', required: true, pattern: String.raw`^-?[0-9]*$`
}

export const RegistrationStatusDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.RegistrationStatus, displayName: 'Registration Status', options: DropdownOptions[FieldNames['RegistrationStatus']]
}

export const commentsText: FormFieldConfig = {
    ...structuredClone(DefaultTextArea),
    fieldName: FieldNames.Comments, displayName: 'Comments', required: true
}

export const BrandText: FormFieldConfig = {
    ...structuredClone(DefaultText),
    fieldName: FieldNames.Brand, displayName: 'Brand'
}

export const TenureSubDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.SubTenure, displayName: 'Select Sub Tenure'
}

export const WorkDayNumber: FormFieldConfig = {
    ...structuredClone(DefaultNumber),
    fieldName: FieldNames.WorkDayId, displayName: 'Workday Id'
}

export const EmailText: FormFieldConfig = {
    ...structuredClone(DefaultEmail), fieldName: FieldNames.Email, displayName: 'Email',
};
export const JobCode: FormFieldConfig = {
    ...structuredClone(DefaultNumber),
    fieldName: FieldNames.JobCode, displayName: 'Job Code', max: 3
}

export const JobCodeDescriptionDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.LexusPrimaryJobCode, displayName: 'Job Code Description', isLoading: true
}

export const VenueAreaDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Area, displayName: 'Area'
}
export const Attachment: FormFieldConfig = {
    ...structuredClone(DefaultFile),
    fieldName: FieldNames.Attachment, displayName: 'Attachment'
}

export const UserAccessScreensDropdown: FormFieldConfig = {
    ...structuredClone(DefaultCheckbox), multiple: true,
    fieldName: FieldNames.UserAccessScreens, displayName: 'User Access Screens', options: DropdownOptions[FieldNames['UserAccessScreens']]
}
export const UserAccessRolesDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.UserAccessRoles, displayName: 'User Access Roles', options: DropdownOptions[FieldNames['UserAccessRoles']]
}
export const RangeDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Range, displayName: 'Range', options: DropdownOptions[FieldNames['Range']], defaultValue: 'year'
}
export const VenuesDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.Venue, displayName: 'Venues'
}
export const IltPartStartDateDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.IltPartStartDate, displayName: 'Start Date', isDependentOn: FieldNames.Venue
}
export const defaultSearchContainerButtons: ButtonFieldConfig[] = [
    { isDisabled: true, name: BUTTON_NAMES.Search, isPrimary: true },
    { isDisabled: true, name: BUTTON_NAMES.Reset }
]

export const defaultExportContainerButtons: ButtonFieldConfig[] = [
    { isDisabled: false, name: BUTTON_NAMES.No },
    { isDisabled: false, name: BUTTON_NAMES.Yes, isPrimary: true }
]

export const defaultManageExceptionPaymentButtons: ButtonFieldConfig[] = [
    { isDisabled: false, name: BUTTON_NAMES.Create, isPrimary: true },
    { isDisabled: false, name: BUTTON_NAMES.Cancel }
]
export const defaultCreateCancelButtons: ButtonFieldConfig[] = [
    { isDisabled: false, name: BUTTON_NAMES.Create, isPrimary: true },
    { isDisabled: false, name: BUTTON_NAMES.Cancel }
]

export const DefaultTenure: FormFieldConfig = {
    fieldName: '', displayName: '', fieldType: FIELD_TYPES.NUMBER, defaultValue: '',
    pattern: String.raw`^[0-9]*$`, selectedValue: '', disabled: false
}

export const ReportOwnerDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.ReportOwner, displayName: 'Report Owner'
}

export const ReportNameDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.ReportName, displayName: 'Report Name', options: DropdownOptions[FieldNames.ReportName]
}


export const EventNameDropdown: FormFieldConfig = {
    ...structuredClone(DefaultDropdown),
    fieldName: FieldNames.EventName, displayName: 'Event Name', options: DropdownOptions[FieldNames.EventName]
}
